import * as React from 'react';

import ActionIcon from './assets/ActionIcon.svg';
import DiscountIcon from './assets/DiscountIcon.svg';
import MaternalCapitalIcon from './assets/MaternalCapitalIcon.svg';
import MilitaryMortgageIcon from './assets/MilitaryMortgageIcon.svg';
import MortgageIcon from './assets/MortgageIcon.svg';
import { EType } from '../../../../types/villagePromotions';

export const PromoIcon = (type: EType, iconUrl?: string | null): React.JSX.Element => {
  if (iconUrl) {
    return <img src={iconUrl} />;
  }

  switch (type) {
    case EType.Sale:
      return <img src={DiscountIcon} />;
    case EType.Mortgage:
      return <img src={MortgageIcon} />;
    case EType.Bonus:
      return <img src={ActionIcon} />;
    case EType.MilitaryMortgage:
      return <img src={MilitaryMortgageIcon} />;
    case EType.MaternalCapital:
      return <img src={MaternalCapitalIcon} />;
  }
};
